import {Pipe, PipeTransform} from '@angular/core';
import {CONSTANTS} from '../../@core/constants';

@Pipe({name: 'constant'})
export class ConstantPipe implements PipeTransform {
    transform(key: string): string {
        return CONSTANTS[key];
    }
}
